<ul class="list-unstyled share-icons d-none d-md-inline-block">
    <li class="share-link"><a href="https://www.youtube.com/channel/UCNo_DAJzrmgoaNZ2E8FXHTA"><i class="fab fa-youtube fa-fw"></i></a> </li>
    <li class="share-link"><a href="https://www.facebook.com/MaDiaChi"><i class="fab fa-facebook fa-fw"></i></a></li>
    <li class="share-link"><a href="https://twitter.com/vietnam_post"><i class="fab fa-twitter fa-fw"></i></a></li>
    <li class="share-link"><a href="https://www.linkedin.com/company/vietnampost/"><i class="fab fa-linkedin fa-fw"></i></a></li>

</ul>
